import "./Loading.css";

const Loading = () => {
  return <div className="spinner-loading"></div>;
};

export default Loading;
